// extracted by mini-css-extract-plugin
export var actionIcon = "_tv-0";